import { forwardRef } from 'react'
import classNames from 'classnames'
import { useSelector } from 'react-redux'
import { createUseStyles, useTheme } from 'react-jss'
import DelayLink from '@/components/DelayLink'
import style from './style'

const useStyles = createUseStyles(style)

const Logo = forwardRef(({
  tabIndex,
  className,
}, ref) => {
  const classes = useStyles()
  const theme = useTheme()

  const strings = useSelector((state) => state.language.string)

  return (
    <div
      className={classNames({
        [classes.root]: true,
        [className]: className,
      })}
      ref={ref}
    >
      <DelayLink
        to={`/${window.pathSite || ''}`}
        className={classes.logo}
        tabIndex={tabIndex}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 175.79 13"
          width={theme.header.logo.width}
        >
          <title>{`${strings.site_title} Logo`}</title>
          <path d="M16.72 12.91V13H0l.72-2.6h12.57a4.59 4.59 0 003.43 2.51zM3.59 0l-.72 2.6h12.51A8.94 8.94 0 0120.26.08V0zM2.15 5.2l-.71 2.6h11.38A6.93 6.93 0 0113 6.5a7.51 7.51 0 01.48-1.3zm23.63-2.6a4.77 4.77 0 00-4.5-2.6l-.72 2.6-.72 2.6-.72 2.6-.72 2.6-.71 2.6h.1a8.68 8.68 0 005.9-2.6A8.69 8.69 0 0026 6.5a5.51 5.51 0 00-.22-3.9zm26.08 0h7.81l.71-2.6h-8.92c-2.17 0-4.4.65-5.2 3.54L43.66 13h3l1.44-5.2h7.13L53.8 13h3L59 5.2H48.81l.19-.66C49.41 3 50.21 2.6 51.86 2.6zm29 7.8l-.77 2.6H70.8l3.57-13h3l-2.85 10.4zm-11.44 0l-.76 2.6h-9.29l3.57-13h3l-2.85 10.4zM136 5.2l-2.18 7.8h-3L133 5.2zm5.88-5.2l-.71 2.6h-12l.71-2.6zm14.05 0l-.71 2.6h-12l.72-2.6zm-11.42 8.74c-.29 1.07-.43 1.66 1.26 1.66h7.31l-.71 2.6h-8c-2.18 0-3.63-1.51-3.06-3.61l1.15-4.19h12l-.72 2.6h-9zM112.84 0l-2.6 9.46c-.8 2.89-3 3.54-5.2 3.54h-7.8l.76-2.6h6.69c1.64 0 2.45-.43 2.87-1.94l.18-.66h-9l2.08-7.8h3l-1.42 5.2h6l1.44-5.2zM87.58 4.54l-.18.66h9.69l-1.17 4.26c-.8 2.89-3 3.54-5.2 3.54h-8.47l.75-2.6h7.36c1.64 0 2.45-.43 2.87-1.94l.18-.66h-9.73l1.17-4.26C85.64.65 87.88 0 90 0h8.47l-.67 2.6h-7.36c-1.64 0-2.44.4-2.86 1.94zm29.31 0l-.18.66h9.69l-1.17 4.26c-.8 2.89-3 3.54-5.2 3.54h-8.47l.71-2.6h7.36c1.64 0 2.45-.43 2.87-1.94l.18-.66H113l1.17-4.26c.8-2.89 3-3.54 5.2-3.54h8.47l-.72 2.6h-7.36c-1.64 0-2.45.4-2.87 1.94zM39.55 0h-8.69l-.72 2.6h8.71c1.66 0 2.21.56 2 1.4-.3 1.08-1.72 1.2-2.71 1.2h-8.7L27.27 13H36c2.12 0 5.41-.11 6.31-3.39a3.2 3.2 0 00-.4-2.69 4.07 4.07 0 001.83-2.51C44.37 2 42.54 0 39.55 0zm-.15 9.2c-.3 1.09-1.73 1.2-2.72 1.2H31l.71-2.6h5.72c1.65 0 2.2.56 1.97 1.4zM175.79 0l-3.57 13h-3l2.86-10.4h-1.88c-1.64 0-2.45.43-2.87 1.94L165 13h-3l2.14-7.8c.57-2.08-.06-2.6-2-2.6h-4.51l.71-2.6h4.82a4.86 4.86 0 013 1 5.84 5.84 0 013.58-1zm-15.71 5.2L157.8 13h-3l2.14-7.8z" />
        </svg>
      </DelayLink>
    </div>
  )
})

export default Logo
